import styled from 'styled-components';
import { Title, Header5 } from 'library/styles/text';
import Colors from 'library/constants/colors';

// eslint-disable-next-line import/prefer-default-export
export const StyledDescription = styled(Header5)`
  color: ${Colors.shade03};
`;

export const StyledTitle = styled(Title)`
  color: ${Colors.shade03};
  margin-top: 15px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  transform: translate(0, -70px);
`;
